import React from 'react';
import Card from '../Card/Card';
import PixelGroupList from '../Pixels/PixelsGroupList';

const OfferPixels = ({
  withLink,
  theme,
  pixels,
  offerId,
  isCdn,
  coins,
  collapsing,
  withoutControls,
  isGambling,
  countries,
  offer_geo,
  geos,
}) => {
  return (
    <>
      {pixels.length > 0 && (
        <PixelGroupList
          theme={theme}
          withLink={withLink}
          id={offerId}
          isCdn={isCdn}
          coins={coins}
          showGroupName
          pixels={pixels}
          countries={countries}
          offer_geo={offer_geo}
          geos={geos}
          isGambling={isGambling}
        />
      )}
    </>
  );
};

export default OfferPixels;
